import TicketModal from './TicketModal';

export default (props) => {
  return <TicketModal {...props} />;
};
